module.exports = __webpack_public_path__ + "static/media/folder-upload-outline.f8972999.svg";